'use client';

import Intercom from '@intercom/messenger-js-sdk';
import { useEffect } from 'react';

import type { IntercomBoot } from './intercom-identity';

type IntercomMessengerProps = {
    // `import type` uniquement : `intercom-identity` est `server-only`, on ne tire que le
    // type (effacé au build), jamais le module ni le secret qu'il lit.
    boot: IntercomBoot | null;
};

/**
 * Monte le messenger Intercom. Rien à rendre : le SDK injecte son propre launcher. Le boot
 * est décidé côté serveur (`buildIntercomBoot`) — ici on ne fait que déclencher l'appel avec
 * un payload déjà signé.
 */
export function IntercomMessenger({ boot }: IntercomMessengerProps) {
    const userId = boot?.user.user_id;

    useEffect(() => {
        if (!boot) return;

        try {
            Intercom({ app_id: boot.appId, ...boot.user });
        } catch (error) {
            // Le messenger ne doit jamais faire remonter d'erreur dans la page (idem tracking).
            console.error('Intercom boot failed', error);
        }
        // Un seul boot, redéclenché par le seul champ qui puisse changer d'identité.
        // eslint-disable-next-line react-hooks/exhaustive-deps -- one boot per identity change, see the note above
    }, [userId]);

    return null;
}
